import { AbogadoService } from "../../../_services/abogados.service";
import { dashboardConstants } from "../constants";

export const getAbogados = () => async (dispatch) => {
  dispatch(request());
  try {
    const response = await AbogadoService.getAbogados();

    if (typeof response === "string") {      
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED, payload: { abogadosList: [] } };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(data) {
    return { type: dashboardConstants.SET_ABOGADOS_LIST, payload: data };
  }
};

export const deleteAbogado = (id) => async (dispatch) => {
  dispatch(request());
  try {
    const data = await AbogadoService.deleteAbogado(id);

    if (typeof data === "string") {
      dispatch(failure(data));
    } else {
      dispatch(success(data));
    }
  } catch (error) {
    dispatch(failure(error.toString()));
  }
  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(payload) {
    return { type: dashboardConstants.SET_ABOGADOS_LIST, payload };
  }
};
